/**
 * Gets the largest resolution image URL from a media URI object.
 *
 * @param uri - Object with resolution keys (e.g., 'original', '480w', '384w') and URL values
 * @returns The URL of the largest resolution image, or empty string if none found
 */
export const getLargestResolutionImageUrl = (
  uri: Record<string, string> | undefined,
): string => {
  if (!uri || Object.keys(uri).length === 0) return '';

  const resolutionEntries = Object.entries(uri)
    .map(([key, url]) => ({
      width: parseInt(key, 10),
      url,
    }))
    .filter(({ width }) => !Number.isNaN(width))
    .sort((a, b) => b.width - a.width);

  return resolutionEntries[0]?.url || Object.values(uri)[0] || '';
};
